console.log("DEBUG: Running testDoppeltorSeitenGrößer...");
